import api from '../utils/api';

export const getWebhookLogs = async (params = {}) => {
  const response = await api.get('/webhooks', { params });
  return response.data;
};

export const getWebhookLog = async (id) => {
  const response = await api.get(`/webhooks/${id}`);
  return response.data;
};
